import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// 딥링크 리스너 등록 (웹에서는 이벤트가 발생하지 않으므로 무해)
import('./lib/deeplink').then(({ setupDeepLinkListener }) => {
  setupDeepLinkListener();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
